import { FormattedMessage } from 'react-intl';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export type PageError =
    | 'VEHICLE_NOT_FOUND'
    | 'TABLE_NOT_FOUND_IN_ATHENA'
    | 'TABLE_NOT_FOUND_IN_ATHENA_FOR_HISTORY_TABLE'
    | 'INTERNAL_ERROR';

export const errorConfig: Record<PageError, { headlineI18n: string; messageI18n: string }> = {
    VEHICLE_NOT_FOUND: {
        headlineI18n: 'intl-msg:maintenanceHistory.error.vehicleNotFound.headline',
        messageI18n: 'intl-msg:maintenanceHistory.error.vehicleNotFound.message',
    },
    TABLE_NOT_FOUND_IN_ATHENA: {
        headlineI18n: 'intl-msg:maintenanceHistory.error.tableNotFound.headline',
        messageI18n: 'intl-msg:maintenanceHistory.error.tableNotFound.message',
    },
    TABLE_NOT_FOUND_IN_ATHENA_FOR_HISTORY_TABLE: {
        headlineI18n: 'intl-msg:maintenanceHistory.error.tableNotFound.historyTable.headline',
        messageI18n: 'intl-msg:maintenanceHistory.error.tableNotFound.message',
    },
    INTERNAL_ERROR: {
        headlineI18n: 'intl-msg:maintenanceHistory.error.internalError.headline',
        messageI18n: 'intl-msg:maintenanceHistory.error.internalError.message',
    },
};

export type InternalErrorStateProps = {
    headlineI18n: string;
    messageI18n: string;
    additionalClassName?: string;
    innerClassName?: string;
    fullWidth?: boolean;
};

const InternalErrorState = ({
    headlineI18n,
    messageI18n,
    additionalClassName,
    innerClassName,
    fullWidth,
}: InternalErrorStateProps) => (
    <ErrorState
        icon={''}
        headline={<FormattedMessage id={headlineI18n} />}
        message={<FormattedMessage id={messageI18n} values={{ linebreak: <br /> }} />}
        // className should keep the original values plus the news values passed
        outerClassName={`${additionalClassName}`}
        innerClassName={innerClassName}
        fullWidth={fullWidth}
    />
);

export default InternalErrorState;
